/* SPDX-FileCopyrightText: Copyright (c) 2026 NVIDIA CORPORATION & AFFILIATES. All rights reserved. */
/* SPDX-License-Identifier: Apache-2.0 */

nve-menu:has(nve-menu-item:state(current)) {
  --padding: 0 0 0 var(--nve-ref-size-200);
}

nve-menu:has(nve-tooltip),
nve-menu:has(nve-tooltip) nve-menu-item {
  content-visibility: initial;
}

nve-menu[density='compact'] {
  --min-width: 0;

  nve-menu-item {
    --gap: 0;
    width: fit-content;
  }

  nve-menu-item::part(_slot),
  nve-menu-item::part(_suffix) {
    display: none !important;
  }
}
